"use client"

import { useTheme } from "next-themes"
import { Toaster as Sonner, type ToasterProps } from "sonner"
import { CircleCheckIcon, InfoIcon, TriangleAlertIcon, OctagonXIcon, Loader2Icon } from "lucide-react"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4 text-emerald-500" />,
        info: <InfoIcon className="size-4 text-[#13429e]" />,
        warning: <TriangleAlertIcon className="size-4 text-amber-500" />,
        error: <OctagonXIcon className="size-4 text-red-500" />,
        loading: <Loader2Icon className="size-4 animate-spin text-gray-400" />,
      }}
      style={
        {
          "--border-radius": "var(--radius)",
          "--normal-bg": "#ffffff",
          "--normal-text": "oklch(0.145 0 0)",
          "--normal-border": "oklch(0.922 0 0)",
          "--success-bg": "#ffffff",
          "--success-text": "oklch(0.145 0 0)",
          "--success-border": "oklch(0.922 0 0)",
          "--error-bg": "#ffffff",
          "--error-text": "oklch(0.145 0 0)",
          "--error-border": "oklch(0.922 0 0)",
          "--info-bg": "#ffffff",
          "--info-text": "oklch(0.145 0 0)",
          "--info-border": "oklch(0.922 0 0)",
          "--warning-bg": "#ffffff",
          "--warning-text": "oklch(0.145 0 0)",
          "--warning-border": "oklch(0.922 0 0)",
          "--width": "360px",
          "--font-size": "0.875rem",
          "--box-shadow": "0 1px 3px 0 rgb(0 0 0 / 0.07), 0 1px 2px -1px rgb(0 0 0 / 0.07)",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: "font-sans! border border-gray-200! bg-white! shadow-sm!",
          title: "text-sm! font-medium! text-gray-900!",
          description: "text-xs! text-gray-500!",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
